import { render, staticRenderFns } from "./vgpSvgImage.vue?vue&type=template&id=ddecd410&scoped=true&"
import script from "./vgpSvgImage.vue?vue&type=script&lang=js&"
export * from "./vgpSvgImage.vue?vue&type=script&lang=js&"
import style0 from "./vgpSvgImage.vue?vue&type=style&index=0&id=ddecd410&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddecd410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddecd410')) {
      api.createRecord('ddecd410', component.options)
    } else {
      api.reload('ddecd410', component.options)
    }
    module.hot.accept("./vgpSvgImage.vue?vue&type=template&id=ddecd410&scoped=true&", function () {
      api.rerender('ddecd410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/common/VueComponents/VueIcon/vgpSvgImage.vue"
export default component.exports